import React from 'react';
import { unstable_createRoot as createRoot } from 'react-dom';
import { View, sx, ThemeProvider, Button, Text, useTheme } from './src';

const Swatch = ({ color, children }) => {
  return (
    <div css={sx({ marginBottom: 2 })}>
      <div
        css={sx({
          width: 20,
          height: 20,
          bg: color,
          boxShadow: 2,
        })}
      />
      <div css={sx({ bg: 'white' })}>
        <Text variant="-2u">{children}</Text>
      </div>
    </div>
  );
};

const Swatches = ({ debug = true }) => {
  const theme = useTheme();
  return (
    <div>
      <div
        css={sx({
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          marginBottom: 5,
        })}
      >
        {theme.colors &&
          Object.entries(theme.colors)
            .reverse()
            .map(([color, code]) =>
              Array.isArray(code) && debug ? (
                <View key={code} sx={{ width: '100%', flexDirection: 'row' }}>
                  {code.map((c, i) => (
                    <View key={`${c}-${i}`} sx={{ padding: 1 }}>
                      <Swatch color={c}>
                        {color}.{i}
                      </Swatch>
                    </View>
                  ))}
                </View>
              ) : (
                <View sx={{ padding: 1, width: '100%' }}>
                  <div key={color}>
                    <Swatch color={color}>{color}</Swatch>
                  </div>
                </View>
              ),
            )}
      </div>
    </div>
  );
};

const App = () => (
  <ThemeProvider>
    <div>
      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button size="lg">lg</Button>
      </div>
      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button>normal</Button>
      </div>
      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button size="sm">sm</Button>
      </div>
      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button size="xs">xs</Button>
      </div>

      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button variant="primary">Primary</Button>
      </div>

      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button variant="alt">alternative</Button>
      </div>

      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button.Ghost>ghost</Button.Ghost>
      </div>

      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button.Ghost variant="primary">ghost primary</Button.Ghost>
      </div>

      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button.Ghost size="xs" variant="alt">
          ghost alt
        </Button.Ghost>
      </div>

      <div
        sx={{
          display: 'flex',
          backgroundColor: 'black',
          padding: '5px 10px',
        }}
      >
        <Button.Ghost variant="light">ghost</Button.Ghost>
      </div>
      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button.Link>normal</Button.Link>
      </div>
      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button.Link variant="primary">primary</Button.Link>
      </div>
      <div css={{ display: 'flex', padding: '5px 10px' }}>
        <Button.Link variant="alt">alt</Button.Link>
      </div>
      <div css={{ padding: '4px' }}>
        <div>
          <Text>default</Text>
        </div>
        <div>
          <Text variant="-2r">-2r</Text>
        </div>
        <div>
          <Text variant="-2u">-2u</Text>
        </div>
        <div>
          <Text variant="-1r">-1r</Text>
        </div>
        <div>
          <Text variant="-1b">-1b</Text>
        </div>
        <div>
          <Text variant="1r">1r</Text>
        </div>
        <div>
          <Text variant="1b">1b</Text>
        </div>
        <div>
          <Text variant="2r">2r</Text>
        </div>
        <div>
          <Text variant="2b">2b</Text>
        </div>
        <div>
          <Text variant="3">3</Text>
        </div>
        <div>
          <Text variant="4">4</Text>
        </div>
        <div>
          <Text variant="5">5</Text>
        </div>
        <div>
          <Text variant="6">6</Text>
        </div>
      </div>
      <Swatches />
    </div>
  </ThemeProvider>
);

const container = document.body;

const root = createRoot(container);

root.render(<App />);
